import { addressFrag } from './common.types';
import { ruleGridItemFrag } from './acl.types';

export const userRoleGridItemFrag = `
    id
    name
`;

export const employmentFrag = `
    id
    organizationId
    serviceId
    employmentTypeName
    contract
    workloadType
    workloadSize
    dateFrom
    dateTo
`;

export const employmentGridFrag = `
    id
    organizationId
    serviceId
    employmentTypeName
    contract
    dateFrom
    dateTo
    workloadSize
    scopeOfWork
    workloadType
    specificName
    note
    workplaces {
        workplaceId
        dateFrom
        dateTo
    }
`;

export const employmentTypeFrag = `
    name
    mpsvId
    classification
    groupName
`;

export const userGridItemMinInfoFrag = `
    canEdit
    address {
        ${addressFrag}
    }
    email
    id
    name
    phone
    surname
    titleAfterName
    titleBeforeName
    sex
    doctor
    image
    active
`;

export const userGridItemListInfoFrag = `
    canEdit
    address {
        ${addressFrag}
    }
    email
    id
    mobile
    name
    phone
    surname
    titleAfterName
    titleBeforeName
    sex
    doctor
    icpOfDoctor
    fax
    personalEmail
    employeeCode
    prevYearsOfExperience
    birthDate
    educationCode
    fieldOfStudy
    image
    employments {
        ${employmentFrag}
    }
    role {
        ${userRoleGridItemFrag}
    }
    active
    organizations {
        id
    }
`;

export const userGridItemFrag = `
    canEdit
    address {
        ${addressFrag}
    }
    email
    id
    mobile
    name
    phone
    surname
    titleAfterName
    titleBeforeName
    sex
    doctor
    icpOfDoctor
    doctorSpecialization
    fax
    personalEmail
    employeeCode
    prevYearsOfExperience
    birthDate
    educationCode
    fieldOfStudy
    image
    employments {
        ${employmentFrag}
    }
    role {
        ${userRoleGridItemFrag}
    }
    active
    organizations {
        id
    }
    groups {
        id
        name
        isPrivate
        rules {
            ${ruleGridItemFrag}
        }
    }
`;

export const userFrag = `
    address {
        ${addressFrag}
    }
    email
    id
    mobile
    name
    phone
    surname
    titleAfterName
    titleBeforeName
    icpOfDoctor
    prevYearsOfExperience
    employments {
        ${employmentFrag}
    }
    role {
        ${userRoleGridItemFrag}
    }
    active
`;

export const serviceUserFrag = `
    id
    name
    surname
    email
    titleAfterName
    titleBeforeName
    doctor
    icpOfDoctor
    prevYearsOfExperience
    image
    sex
`;

export const userWorkplaceFrag = `
    id
    name
    address {
        ${addressFrag}
    }
    validFrom
    validTo
    active
    hours {
        type
        day
        from
        to
    }
`;

export const userExperienceItemFrag = `
    id
    name
    date
    hours
    countInEducation
    employmentTypeEducationId
    file
    userId
`;

export const userSecretsItemFrag = `
    id
    type
    validFrom
    validTo
    userId
    user {
        titleBeforeName
        name
        surname
        titleAfterName
        email
        icpOfDoctor
    }
`;
